import * as THREE from "three";
import { Context } from "../core/context";
import { DbLine } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  ElevationAnnotationModifyReturnData,
} from "@/core/Parameters";

class ElevationAnnotationModify implements IModifyOperation {
  private m_context: Context;
  private m_locationObject: THREE.Line;
  private m_auxLine: THREE.Line | undefined;
  private m_returnData: ElevationAnnotationModifyReturnData = {
    basePoint: [],
    dirPoint: undefined,
    dirState: undefined,
  };
  private m_TextLabel: ULabel;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_points: THREE.Vector3[] = [];
  private m_scale: number = 1;
  private m_tempObjectGroup: THREE.Group = new THREE.Group();
  private m_tempObject: THREE.LineSegments | undefined;
  private m_baseX = 0.4 * Math.sin(Math.PI / 4);
  private m_baseY = 0.4 * Math.cos(Math.PI / 4);
  private m_baseLineLength = 1.5;
  private m_baseLine1Points = [
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(this.m_baseX, this.m_baseY, 0),
  ];
  private m_baseLine2Points = [
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(-this.m_baseX, this.m_baseY, 0),
  ];
  private m_baseLine3Points = [
    new THREE.Vector3(-this.m_baseX, this.m_baseY, 0),
    new THREE.Vector3(-this.m_baseX + this.m_baseLineLength, this.m_baseY, 0),
  ];
  private m_dirState = "rightTop";
  private m_callbackUnderway: (point: THREE.Vector3) => void;
  private m_isShift: Boolean = false;

  constructor(
    context: Context,
    callbackUnderway: (point: THREE.Vector3) => void
  ) {
    this.m_context = context;
    this.m_callbackUnderway = callbackUnderway;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();

    this.m_scale = this.m_context.ViewManager.ScreenModelScale;

    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_context.SceneManager.AuxModel.add(this.m_tempObjectGroup);
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point.clone();
    this.m_locationObject.position.copy(this.m_curPoint);
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 55;
    TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    if (this.m_points.length > 0) {
      if (this.m_points.length <= 2) {
        if (this.m_isShift) {
          this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
            this.m_curPoint,
            this.m_points[0]
          );
        }
        this.m_auxLine?.geometry.setFromPoints([
          this.m_points[0],
          this.m_curPoint,
        ]);
      } else {
        if (this.m_isShift) {
          this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
            this.m_curPoint,
            this.m_points[this.m_points.length - 1]
          );
        }
        this.m_auxLine?.geometry.setFromPoints([
          this.m_points[this.m_points.length - 1],
          this.m_curPoint,
        ]);
      }
      this.m_auxLine?.computeLineDistances();
    }
    if (this.m_points.length > 1) {
      this.m_tempObject?.position.copy(this.m_curPoint.clone());
    }
    if (this.m_points.length == 0) {
      this.m_TextLabel.SetVaule(
        "请点取标高点,长按Shift锁定正交",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    } else if (this.m_points.length == 1) {
      this.m_TextLabel.SetVaule(
        "请选取标高方向,长按Shift锁定正交",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      this.updateCurTempObjectDir();
    } else if (this.m_points.length >= 2) {
      this.m_TextLabel.SetVaule(
        "请点取下一点,长按Shift锁定正交",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    this.m_points.push(this.m_curPoint.clone());
    this.createTempObject();

    if (this.m_points.length == 1) {
      this.m_tempObject?.position.copy(this.m_curPoint.clone());
      this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
      this.m_returnData.basePoint.push(this.m_curPoint.clone());
    }

    if (this.m_points.length == 2) {
      this.m_returnData.dirPoint = this.m_curPoint.clone();
      this.m_callbackUnderway(this.m_curPoint.clone());
    }
    if (this.m_points.length > 2) {
      this.m_returnData.basePoint.push(this.m_curPoint.clone());
      this.m_callbackUnderway(this.m_curPoint.clone());
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = true;
    }
  }
  onKeyUp(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = false;
    }
  }

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      if (this.m_dirState == "leftTop") {
        this.m_returnData.dirState = 0;
      } else if (this.m_dirState == "rightTop") {
        this.m_returnData.dirState = 1;
      } else if (this.m_dirState == "leftBottom") {
        this.m_returnData.dirState = 2;
      } else if (this.m_dirState == "rightBottom") {
        this.m_returnData.dirState = 3;
      }
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private createTempObject() {
    let tempOriginPoints = [
      ...this.m_baseLine1Points,
      ...this.m_baseLine2Points,
      ...this.m_baseLine3Points,
    ];
    let geo = new THREE.BufferGeometry().setFromPoints(tempOriginPoints);
    let material = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let tempObject = new THREE.LineSegments(geo, material);
    this.m_tempObject = tempObject;
    this.m_tempObjectGroup.add(tempObject);
  }

  private updateCurTempObjectDir() {
    let xAxis = new THREE.Vector3(1, 0, 0);
    let curVectorNormal = this.m_curPoint
      .clone()
      .sub(this.m_points[0])
      .normalize();
    let angle = xAxis.angleTo(curVectorNormal);
    if (curVectorNormal.clone().cross(xAxis).z > 0) {
      angle = -angle;
    }
    if (this.m_dirState == "rightTop") {
      if (angle > (Math.PI / 4) * 3) {
        //>135
        this.m_dirState = "leftTop";
      } else if (angle < -Math.PI / 4) {
        //<-45
        this.m_dirState = "rightBottom";
      }
    } else if (this.m_dirState == "leftTop") {
      if (angle < Math.PI / 4 && angle > 0) {
        //0-45
        this.m_dirState = "rightTop";
      } else if (angle > -(Math.PI / 4) * 3 && angle < 0) {
        //-135 - 0
        this.m_dirState = "leftBottom";
      }
    } else if (this.m_dirState == "rightBottom") {
      if (angle < -(Math.PI / 4) * 3) {
        //<-135
        this.m_dirState = "leftBottom";
      } else if (angle > Math.PI / 4) {
        //>45
        this.m_dirState = "rightTop";
      }
    } else if (this.m_dirState == "leftBottom") {
      if (angle > -Math.PI / 4 && angle < 0) {
        //> -45 - 0
        this.m_dirState = "rightBottom";
      } else if (angle < (Math.PI / 4) * 3 && angle > 0) {
        // >135
        this.m_dirState = "leftTop";
      }
    }
    switch (this.m_dirState) {
      case "rightTop":
        this.m_baseLine1Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(this.m_baseX, this.m_baseY, 0),
        ];
        this.m_baseLine2Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(-this.m_baseX, this.m_baseY, 0),
        ];
        this.m_baseLine3Points = [
          new THREE.Vector3(-this.m_baseX, this.m_baseY, 0),
          new THREE.Vector3(
            -this.m_baseX + this.m_baseLineLength,
            this.m_baseY,
            0
          ),
        ];
        break;
      case "leftTop":
        this.m_baseLine1Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(this.m_baseX, this.m_baseY, 0),
        ];
        this.m_baseLine2Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(-this.m_baseX, this.m_baseY, 0),
        ];
        this.m_baseLine3Points = [
          new THREE.Vector3(this.m_baseX, this.m_baseY, 0),
          new THREE.Vector3(
            this.m_baseX - this.m_baseLineLength,
            this.m_baseY,
            0
          ),
        ];
        break;
      case "rightBottom":
        this.m_baseLine1Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(this.m_baseX, -this.m_baseY, 0),
        ];
        this.m_baseLine2Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(-this.m_baseX, -this.m_baseY, 0),
        ];
        this.m_baseLine3Points = [
          new THREE.Vector3(-this.m_baseX, -this.m_baseY, 0),
          new THREE.Vector3(
            -this.m_baseX + this.m_baseLineLength,
            -this.m_baseY,
            0
          ),
        ];
        break;
      case "leftBottom":
        this.m_baseLine1Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(this.m_baseX, -this.m_baseY, 0),
        ];
        this.m_baseLine2Points = [
          new THREE.Vector3(0, 0, 0),
          new THREE.Vector3(-this.m_baseX, -this.m_baseY, 0),
        ];
        this.m_baseLine3Points = [
          new THREE.Vector3(this.m_baseX, -this.m_baseY, 0),
          new THREE.Vector3(
            this.m_baseX - this.m_baseLineLength,
            -this.m_baseY,
            0
          ),
        ];
        break;
    }

    let tempOriginPoints = [
      ...this.m_baseLine1Points,
      ...this.m_baseLine2Points,
      ...this.m_baseLine3Points,
    ];
    this.m_tempObject?.geometry.setFromPoints(tempOriginPoints);
  }

  private clear() {
    this.m_context.ToolsManager.GroupClear(this.m_tempObjectGroup);
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_TextLabel?.dispose();
  }
}

export { ElevationAnnotationModify };
